import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';

export function encryptWithAES<T>(data: T, passphrase: string) {
	const cipherParams = AES.encrypt(JSON.stringify(data), passphrase);

	return cipherParams.toString();
}

export function decryptWithAES<T>(encryptedData: ReturnType<typeof encryptWithAES>, passphrase: string): T {
	return JSON.parse(AES.decrypt(encryptedData, passphrase).toString(encUtf8)) as T;
}
